module.exports = __webpack_public_path__ + "static/media/video1.cd8b079c.mp4";